import ordersActions from './actions';
import getters from './getters';
import ordersMutations from './mutations';
import storeResourceFactory from '../../libs/storeResourceFactory';

const byWeekStore = storeResourceFactory('byWeek', {});

const byUserWeekStore = storeResourceFactory('byUserWeek', []);

const insertOrderStore = storeResourceFactory('insertOrder', undefined);

const removeOrderByIdStore = storeResourceFactory('removeOrder', undefined);
const removeOrderByMenuEventStore = storeResourceFactory('removeOrderByMenuEvent', undefined);

const state = {
  ...byWeekStore.state,
  ...byUserWeekStore.state,
  ...insertOrderStore.state,
  ...removeOrderByIdStore.state,
  ...removeOrderByMenuEventStore.state,
  userOrdersIdsBeforeSync: [],
  wereOrdersUpdated: null,
  office: '',
  loading: false,
  bulkCreationOrdersCorrectly: undefined,
};

const actions = {
  initializeWeekOrders: byWeekStore.request(ordersActions.initializeWeekOrders),
  initializeWeekOrdersByUser: byUserWeekStore.request(ordersActions.initializeWeekOrdersByUser),
  validateUserOrdersSync: ordersActions.validateUserOrdersSync,
  insertOrder: insertOrderStore.request(ordersActions.insertOrder),
  removeOrderById: removeOrderByIdStore.request(ordersActions.removeOrderById),
  removeOrderByMenuEvent: removeOrderByMenuEventStore.request(ordersActions.removeOrderByMenuEvent),
  removeOrdersByDay: byUserWeekStore.request(ordersActions.removeOrdersByDay),
  removeWeekOrdersByEvent: byUserWeekStore.request(ordersActions.removeWeekOrdersByEvent),
  removeWeekOrders: byUserWeekStore.request(ordersActions.removeWeekOrders),
  checkOutUserOrder: ordersActions.checkOutUserOrder,
  createBulkOrders: ordersActions.createBulkOrders,
};

const mutations = {
  ...byWeekStore.mutations,
  ...byUserWeekStore.mutations,
  ...insertOrderStore.mutations,
  ...removeOrderByIdStore.mutations,
  ...removeOrderByMenuEventStore.mutations,
  ...ordersMutations,
  SET_LOADING: (state, value) => {
    state.loading = value;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./store/modules/orders/index.js